
          import "Toggle_13jy25t.linaria.css";
          import React, { useContext } from "react";
import { styled } from "@linaria/react";
import { typeStyle } from "@carvana/showroom-css-theme";
import Tabs from "./Base/Tabs";
import TabContext from "./Base/TabContext";
import { defaultProps as defaultPanelProps } from "./Base/Panel/Props";
const HEIGHT = 40;
export const SwitchButton = /*#__PURE__*/styled("div")({
  name: "SwitchButton",
  class: "s17n4l1m"
});
export const SlidingBackground = /*#__PURE__*/styled("div")({
  name: "SlidingBackground",
  class: "sbi5fgh",
  vars: {
    "sbi5fgh-1": [props => props.isOn ? "translateX(100%) translateX(-19px) translateY(-1px)" : "translate(-1px, -1px)"]
  }
});
export const SwitchLabel = /*#__PURE__*/styled("div")({
  name: "SwitchLabel",
  class: "s1nf4p7i",
  vars: {
    "s1nf4p7i-3": [props => !props.isSelected ? "var(--cvna-color-grey-5)" : ""],
    "s1nf4p7i-4": [props => !props.isSelected ? "var(--cvna-color-blue-6)" : "inherit"]
  }
});
const defaultProps = {
  className: "",
  testHook: "Toggle"
};
export const StorybookProps = props => null;

const Toggle = ({
  options = [],
  className,
  testHook
}) => {
  const {
    activeTab,
    setActiveTab
  } = useContext(TabContext);
  const isOn = activeTab === options[1].value;

  const toggleSelection = toIndex => {
    setActiveTab(options[toIndex].value);
  };

  return /* @__PURE__ */React.createElement(SwitchButton, {
    role: "tablist",
    className,
    "data-testid": testHook
  }, /* @__PURE__ */React.createElement(SlidingBackground, {
    isOn
  }), options.map(({
    value,
    display
  }, i) => {
    const isSelected = Number(isOn) === i;
    return /* @__PURE__ */React.createElement(SwitchLabel, {
      role: "tab",
      "aria-selected": isSelected,
      key: value,
      isSelected,
      onClick: () => toggleSelection(i),
      index: i
    }, display);
  }));
};

Toggle.defaultProps = defaultProps;
Tabs.Toggle = Toggle;
const TogglePanel = /*#__PURE__*/styled(Tabs.Panel)({
  name: "TogglePanel",
  class: "tuj3b5a"
});

const TPanel = props => /* @__PURE__ */React.createElement(TogglePanel, { ...props
});

TPanel.defaultProps = defaultPanelProps;
Tabs.Toggle.Panel = TPanel;
export default Tabs;
          